import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

function SimChart(props) {
  return (
    <ResponsiveContainer width="100%" height={250}>
      <LineChart
        data={props.data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <Tooltip />
        <XAxis dataKey="date" />
        <YAxis />
        <Line type="monotone" dataKey="mbs_used_cumulative" stroke="#8884d8" />
      </LineChart>
    </ResponsiveContainer>
  );
}

export default SimChart;
